import ApiService from './ApiService';

const API_URLS = window.AppConfig.API_URLS;

export default class RatingsService {
	/**
	 * This functions are used for Ratings related tasks.
	 * @return {}
	 */

	static async getUserRating(id, queryUrl) {
		return ApiService.GetData(`${API_URLS.RATING_BY_ID}/${id}${queryUrl}`, 'ratings', true);
	}

	static async setUserRating(requestBody) {
		return ApiService.PostData(`${API_URLS.SET_RATING}`, requestBody, 'ratings');
	}

	static async replaceUserRating(requestBody) {
		return ApiService.PutData(`${API_URLS.REPLACE_RATING}`, requestBody, 'ratings');
	}

	static async listRatingByLoanId(loan_id) {
		return ApiService.GetData(`${API_URLS.LIST_RATING_BY_LOAN_ID}/${loan_id}`, 'ratings');
	}
}
